<template>
  <section
    id="app-logo"
    @click="logoAction"
    class="logo-holder pointer"
    :class="{
      background: scrollPosition > 50 || !isRijnja || $route.name !== 'home'
    }"
  >
    <img
      v-if="customLogo === false"
      id="rijnja-logo"
      class="logo"
      alt="Logo Koninklijke Rijnja"
      src="../images/logo/rijnja_prints_voor_professionals_logo.svg"
    />

    <img
      class="custom-logo"
      v-else
      id="custom-logo"
      :src="customLogo"
      :style="{
        maxHeight: rootStore.theme.header.menuRight.customLogoHeight
      }"
    />
  </section>
</template>

<script>
export default {
  data() {
    return {
      scrollPosition: null
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll)
  },
  computed: {
    customLogo() {
      if (this.rootStore.theme.header.menuRight.customLogo) {
        return (
          '//images.rijnja.nl/images/logos/themes' +
          this.rootStore.theme.header.menuRight.customLogo
        )
      } else {
        return false
      }
    },
    isRijnja() {
      return this.rootStore.theme.showRijnjaContent
    }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    logoAction() {
      if (this.$route.name === 'home') {
        this.$router.push({ name: 'contact' })
      } else {
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-holder {
  position: fixed;
  padding: 0 15px;
  z-index: 10;
  background-color: white;
  border-radius: 30px;
  top: 15px;
  right: 15px;
  box-shadow: rgba($color: #000000, $alpha: 0.33) 0 0px 32px -4px;
  height: 46px;
  display: flex;
  align-items: center;
}

.logo {
  width: 160px;
  height: 100%;
}

.custom-logo {
  //  margin-top: 7px;
  max-height: 32px;
  max-width: 150px;
  height: 100%;
}

@media only screen and (min-width: 940px) {
  .logo-holder {
    top: 32px;
    right: 32px;
  }
}

@media only screen and (min-width: 768px) {
  .logo-holder {
    background-color: transparent;
    box-shadow: none;
    transition: all 0.2s;

    &.background {
      background: white;
      box-shadow: rgba($color: #000000, $alpha: 0.33) 0 0px 32px -4px;
      height: 46px;
      padding: 0 20px;

      .logo {
        width: 150px;
      }
    }
  }

  .logo {
    width: 252px;
    transition: all 0.2s;
  }
}
</style>
